import React, { useState, useEffect, useContext, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

import {
  Select,
  MenuItem,
  TextField,
  FormControlLabel,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Modal,
  Grid,
  Typography,
} from '@material-ui/core';
// import { DatePicker } from '@material-ui/pickers'
import GoogleMapsAutoComplete from '../components/GoogleMapsAutoComplete';
import styles from "assets/jss/material-kit-react/views/landingPage.js";
import { useSelector, useDispatch } from "react-redux";
import AlertDialog from '../components/AlertDialog';
import { language } from 'config';
import { FirebaseContext } from 'common';
import PaymentGateway from './SelectGateway';

const useStyles = makeStyles(theme => ({
  ...styles,
  modal: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: 440,
    backgroundColor: "#F2F1F0",
    border: '0px solid #08313A',
    //borderRadius:'5',
    boxShadow: theme.shadows[3],
    padding: theme.spacing(3, 5, 3),
  },
}));

export default function NewDelivery(props) {
  const { api } = useContext(FirebaseContext);
  const {
    getEstimate,
    clearEstimate,
    addBooking,
    clearBooking,
    MinutesPassed,
    GetDateString,
    validateSubscription,
    addDelivery,
    updateWalletBalance
  } = api;
  const classes = useStyles();
  const dispatch = useDispatch();
  const cartypes = useSelector(state => state.cartypes.cars);
  const estimated = useSelector(state => state.estimatedata);
  const bookingdata = useSelector(state => state.bookingdata);
  const settings = useSelector(state => state.settingsdata.settings);
  const [carType, setCarType] = useState(language.select_delivery);
  const auth = useSelector(state => state.auth);

  const [optionModalStatus, setOptionModalStatus] = useState(false);
  const [receiverInfoModal, setReceiverInfoModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [selectedCarDetails, setSelectedCarDetails] = useState(null);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const rootRef = useRef(null);
  const [subscription, setSubscription] = useState(false);
  const [useSubscription, setUseSubscription] = useState(false);
  const [paymentData, setPaymentData] = useState({})

  const [deliveryInfo, setDeliveryInfo] = useState({
    pickupAddress:null,
    dropAddress:null,
    bookingType: "Book Now",
    selectedDate: GetDateString(),
    tempRoute:""
  })
  
  const handleDeliveryInfo = ({ name, value }) => {
    if (name === "selectedDate") {
      const selectedDate = new Date(value)
      const fiveDays = Date.now() + 5 * 86400000;
      if (selectedDate < new Date()) 
          value = ""
      if (selectedDate > new Date(fiveDays) || selectedDate.getDay() === 0) 
          value = ""
      if (selectedDate.getHours()<9 || selectedDate.getHours()>21)
          value = ""
    }
    setDeliveryInfo({
      ...deliveryInfo,
      [name]:value,
    })
  };
  const [instructionData, setInstructionData] = useState({
    deliveryPerson: "",
    deliveryPersonPhone: "",
    pickUpInstructions: "",
    deliveryInstructions: "",
    parcelTypeIndex: 0,
    optionIndex: 0,
    parcelTypeSelected: null,
    optionSelected: null
  });

  const handleChange = (e) => {
    if (e.target.name === 'parcelTypeIndex') {
      setInstructionData({
        ...instructionData,
        parcelTypeIndex: parseInt(e.target.value),
        parcelTypeSelected: selectedCarDetails?.parcelTypes[e.target.value]
      });
    } else if (e.target.name === 'optionIndex') {
      setInstructionData({
        ...instructionData,
        optionIndex: parseInt(e.target.value),
        optionSelected: selectedCarDetails?.options[e.target.value]
      });
    } else {
      setInstructionData({ ...instructionData, [e?.target?.name]: e?.target?.value });
    }
  };

  const handleCarSelect = (value) => {
    setCarType(value);
    const carDetails = cartypes?.find(car => car.id === value);
    if (carDetails?.name === "ΣΥΜΒΟΛΑΙΟ PRO") setSubscription(true)
    else setSubscription(false)
    let instObj = { ...instructionData };
    instObj.parcelTypeSelected = carDetails?.parcelTypes?carDetails?.parcelTypes[0]:null;
    instObj.parcelTypeIndex = 0;
    instObj.optionSelected = carDetails?.options?carDetails?.options[0]:null;
    instObj.optionIndex = 0;
    setInstructionData(instObj);
    setSelectedCarDetails(carDetails);
  };

  const handleDeliverInfo = (e) => {
    e.preventDefault();
    if (auth.info) {
      if (deliveryInfo?.pickupAddress && deliveryInfo?.dropAddress) {
        const directionService = new window.google.maps.DirectionsService();
        directionService.route(
          {
            origin: new window.google.maps.LatLng(deliveryInfo?.pickupAddress?.coords?.lat, deliveryInfo?.pickupAddress?.coords?.lng),
            destination: new window.google.maps.LatLng(deliveryInfo?.dropAddress?.coords?.lat, deliveryInfo?.dropAddress?.coords?.lng),
            travelMode: window.google.maps.TravelMode.DRIVING
          },
          (result, status) => {
            if (status === window.google.maps.DirectionsStatus.OK) {
              const route = {
                distance: (result?.routes[0].legs[0].distance.value / 1000),
                duration: result?.routes[0].legs[0].duration.value,
                polylinePoints: result?.routes[0].overview_polyline
              };
              handleDeliveryInfo({ name: "tempRoute", value: route });
              if (deliveryInfo?.bookingType === 'Book Later' && !deliveryInfo?.selectedDate) 
                setCommonAlert({ open: true, msg: language.select_proper });
              else if (!MinutesPassed(deliveryInfo?.selectedDate) >= 15)
                setCommonAlert({ open: true, msg: language.past_booking_error });
              else if (!selectedCarDetails&&!subscription)
                setCommonAlert({ open: true, msg: language.select_proper }); 
              else setReceiverInfoModal(true);
            } else {
              setCommonAlert({ open: true, msg: language.place_to_coords_error })
            }
          }
        )
      } else {
        setCommonAlert({ open: true, msg: language.select_proper })
      }
    } else {
      setCommonAlert({ open: true, msg: language.must_login })
    }
  };

  const confirmBooking = () => {
    if (subscription) {
      handleGetEstimate();
    }
    else if (Array.isArray(selectedCarDetails.options) || Array.isArray(selectedCarDetails.parcelTypes)) {
      setReceiverInfoModal(false);
      setOptionModalStatus(true);
    } else {
      handleEstimateChange()
    }
  };
  const handleGetEstimate = () => {
    setOptionModalStatus(false);
    let estimateRequest = {
      pickup: deliveryInfo.pickupAddress,
      drop: deliveryInfo.dropAddress,
      carDetails: selectedCarDetails,
      instructionData: instructionData,
      routeDetails: deliveryInfo.tempRoute
    };
    dispatch(getEstimate(estimateRequest));
  };

  useEffect(() => {
    if (subscription && estimated?.estimate && selectedCarDetails) {
       payment();
    }
  }, [estimated?.estimate])

  const handleEstimateChange = () => {
    handleGetEstimate();
    setReceiverInfoModal(false);
    setOptionModalStatus(false);
    setPaymentModal(true);
  };
  const useAccountBalance = (e) => {
    e.preventDefault()
    if (parseFloat(auth?.info?.profile?.walletBalance) >= parseFloat(estimated.estimate.estimateFare)) {
      let walletBalance = parseFloat(auth?.info?.profile?.walletBalance) - parseFloat(estimated.estimate.estimateFare);
      let tDate = new Date();
      let time = tDate.getTime();
      let details = {
        type: 'Debit',
        amount: parseFloat(estimated.estimate.estimateFare),
        date: tDate.toString(),
        txRef: time.toString(),
        transaction_id: time.toString()
      }
      dispatch(updateWalletBalance(walletBalance, details));
      payment("useBalance")
    } else {
      setCommonAlert({ open: true, msg: "no balance available" })
    }
  };

  const payment = (type) => {
    if (instructionData.deliveryPerson && instructionData.deliveryPersonPhone) {
      setReceiverInfoModal(false);
      setPaymentModal(false);
      setOptionModalStatus(false)
      let bookingObject = {
        pickup: deliveryInfo.pickupAddress,
        drop: deliveryInfo.dropAddress,
        carDetails: selectedCarDetails,
        userDetails: auth.info,
        estimate: estimated?.estimate,
        instructionData: instructionData,
        tripdate: new Date(deliveryInfo.selectedDate).toString(),
        bookLater: deliveryInfo.bookingType === 'Book Later' ? true : false,
        settings: settings,
        booking_type_web: true
      };
      if (subscription) {
        addDelivery(auth.info.uid).then((res) => {
        }).catch(() => { })
        dispatch(addBooking(bookingObject));
        dispatch(clearEstimate());
      } else if (type === 'cashOnDelivery') {
        dispatch(addBooking(bookingObject));
        dispatch(clearEstimate());
      }
      else if (type === 'useBalance') {
        dispatch(addBooking(bookingObject));
        dispatch(clearEstimate());
      } else {
        setPaymentData({
          data: {
            ...bookingObject
          },
          amount: estimated?.estimate?.estimateFare,
          paymentType: "booking"
        })
        dispatch(clearEstimate());
      }
    } else {
      setCommonAlert({ open: true, msg: language.deliveryDetailMissing })
    }
  };


  const handleEstimateModalClose = (e) => {
    e.preventDefault();
    setReceiverInfoModal(false);
    dispatch(clearEstimate());
  };

  const handleEstimateErrorClose = (e) => {
    e.preventDefault();
    dispatch(clearEstimate());
  };

  const handleBookingAlertClose = (e) => {
    e.preventDefault();
    dispatch(clearBooking());
    dispatch(clearEstimate());
    props.history.push('/userbookings');
  };

  const handleBookingErrorClose = (e) => {
    e.preventDefault();
    dispatch(clearEstimate());
    dispatch(clearBooking());
  };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  const handleSubscription = () => {
    validateSubscription(auth?.info?.uid).then((res) => {
      if (res && res.success) {
        setSubscription(true)
        setUseSubscription(true)
      } else if (res && res.error) {
        // setTitle(res.error)
        setSubscription(false)
        setUseSubscription(false)
      }
    }).catch(() => {
      setSubscription(false)
      setUseSubscription(false)
      setCommonAlert({ open: true, msg: 'error' })
    })
  };
  useEffect(() => {
    handleSubscription()
  },[])
  useEffect(() => {
    if (useSubscription) {
      const val = cartypes?.filter(carTypes => { return carTypes.name === 'ΣΥΜΒΟΛΑΙΟ PRO' })
      handleCarSelect(val[0].id)
    }
  }, [useSubscription])


  
  return (
    <div>
      <div>
          <div className={classes.container}>
            <GridContainer spacing={2}>
              <GridItem xs={12} sm={12} md={6} lg={6}>
                <GoogleMapsAutoComplete
                  placeholder={language.pickup_location}
                  variant={"standard"}
                  value={deliveryInfo.pickupAddress}
                  defaultValue={auth?.info?.profile?.startAddress} // remove useEffect and just add  defaultValue filed with user Address
                  onChange={
                    (value) => {
                      handleDeliveryInfo({ name: "pickupAddress" , value});
                    }
                  }
                />
              </GridItem>
            </GridContainer>
            <GridContainer spacing={2}>
              <GridItem xs={12} sm={12} md={6} lg={6}>
                <GoogleMapsAutoComplete
                  placeholder={language.drop_location}
                  variant={"standard"}
                  value={deliveryInfo.dropAddress}
                  onChange={
                    (value) => {
                      handleDeliveryInfo({ name: "dropAddress", value });
                    }
                  }
                />
              </GridItem>
            </GridContainer>
          {/* {auth?.info?.profile?.subscription&&<GridContainer spacing={2}>
              <GridItem xs={12} sm={12} md={6} lg={6}>
                <FormControlLabel control={<Checkbox onChange={handleSubscription}  checked={subscription} />} label="Use subscription" />
              </GridItem>
            </GridContainer>} */}
           <GridContainer spacing={2}>
              <GridItem xs={12} sm={12} md={6} lg={6}>
                <FormControl variant="standard" style={{ width: '100%' }}>
                  <Select
                    id="car-type-native"
                    value={carType}
                    onChange={(e) => handleCarSelect(e.target.value)}
                    className={carType === language.select_delivery ? classes.inputdimmed : classes.input}
                    // disabled={role === 'professional' ? true : false}
                  >
                    <MenuItem value={language.select_delivery} key={language.select_delivery} disabled>
                      {language.select_delivery}
                    </MenuItem>
                    {
                    cartypes?.filter(car => !useSubscription ? (car.name !== "ΣΥΜΒΟΛΑΙΟ PRO") : car).map((car) =>
                        <MenuItem key={car.id} value={car.id} >
                          <img src={car.image} className={classes.carphoto} alt="parcel types" />{car.name}
                        </MenuItem>
                      )
                    }
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
            <GridContainer spacing={2}>
              <GridItem xs={12} sm={12} md={6} lg={6}>
                <FormControl variant="standard" style={{ width: '100%' }}>
                  <Select
                    id="booking-type-native"
                    value={deliveryInfo.bookingType}
                    onChange={(e) => handleDeliveryInfo({ name: "bookingType", value: e.target.value })}
                    className={classes.input}
                    inputProps={{ 'aria-label': 'Without label' }}
                  >
                    <MenuItem key={"Book Now"} value={"Book Now"}>
                      {language.book_now}
                    </MenuItem>
                    <MenuItem key={"Book Later"} value={"Book Later"}>
                      {language.book_later}
                    </MenuItem>
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
            <GridContainer spacing={2}>
              {deliveryInfo.bookingType === 'Book Later' ?
                <GridItem xs={12} sm={12} md={6} lg={6}>
                <TextField
                    id="datetime-local"
                    label={language.booking_date_time}
                    type="datetime-local"
                    variant="standard"
                    fullWidth
                    className={classes.commonInputStyle}
                    InputProps={{
                      className: classes.input
                    }}
                    value={deliveryInfo.selectedDate}
                    onChange={(e) => handleDeliveryInfo({ name: "selectedDate", value: e.target.value })}
                />
                </GridItem>
                : null}
            </GridContainer>
            <GridContainer style={{ marginTop: 30, marginBottom: 20 }} spacing={2}>
              <GridItem xs={12} sm={12} md={deliveryInfo.bookingType === 'Book Later' ? 6 : 6} lg={deliveryInfo.bookingType === 'Book Later' ? 6 : 6}>
                <Button
                  round={true}
                  color="success"
                  size="lg"
                  rel="noopener noreferrer"
                  className={classes.items}
                  onClick={handleDeliverInfo}
                  style={{ height: deliveryInfo.bookingType === 'Book Later' ? 52 : 52, fontSize: 20 }}
                >
                  {language.book}
                </Button>
              </GridItem>
            </GridContainer>
          </div>
      </div>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={receiverInfoModal}
        onClose={handleEstimateModalClose}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid container spacing={1} className={classes.paper}>
          <Typography component="h3" variant="h6" color="primary" style={{ marginTop: 15 }}>
            {language.delivery_information}
          </Typography>
          <Grid item xs={12}>
            <TextField
              color="success"
              variant="standard"
              fullWidth
              id="deliveryPerson"
              label={language.deliveryPerson}
              name="deliveryPerson"
              autoComplete="deliveryPerson"
              onChange={handleChange}
              value={instructionData.deliveryPerson}
              autoFocus
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              color="success"
              variant="standard"
              fullWidth
              id="deliveryPersonPhone"
              label={language.deliveryPersonPhone}
              name="deliveryPersonPhone"
              autoComplete="deliveryPersonPhone"
              onChange={handleChange}
              value={instructionData.deliveryPersonPhone}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              color="success"
              variant="outlined"
              multiline rows={3}
              fullWidth
              id="pickUpInstructions"
              label={language.pickUpInstructions}
              name="pickUpInstructions"
              autoComplete="pickUpInstructions"
              onChange={handleChange}
              value={instructionData.pickUpInstructions}
            />
          </Grid>
          {/* //To add if its type of contract to show, otherwise NOT */}
          <Grid item xs={12}>
            <TextField
              color="success"
              variant="outlined"
              helperText="Αν είναι αντικαταβολή γράψτε το ποσό"
              fullWidth
              id="deliveryInstructions"
              label={language.deliveryInstructions}
              name="deliveryInstructions"
              autoComplete="deliveryInstructions"
              onChange={handleChange}
              value={instructionData.deliveryInstructions}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Button round onClick={()=>confirmBooking()} variant="contained" color="success" style={{ marginLeft: 10 }}>
              {language.book_now}
            </Button>
            <Button onClick={handleEstimateModalClose} simple color="warning">
              {language.cancel}
            </Button>
          </Grid>
        </Grid>
      </Modal>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={optionModalStatus}
        onClose={()=>setOptionModalStatus(false)}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid container spacing={2} className={classes.paper}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {selectedCarDetails && selectedCarDetails.parcelTypes ?
              <FormControl component="fieldset">
                <FormLabel component="legend">{language.parcel_types}</FormLabel>
                <RadioGroup name="parcelTypeIndex" value={instructionData.parcelTypeIndex} onChange={handleChange}>
                  {selectedCarDetails.parcelTypes.map((element, index) =>
                    <FormControlLabel key={element.description} value={index} control={<Radio />} label={settings.symbol + ' ' + element.amount + ' - ' + element.description} />
                  )}
                </RadioGroup>
              </FormControl>
              : null}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {selectedCarDetails && selectedCarDetails.options ?
              <FormControl component="fieldset">
                <FormLabel component="legend">{language.options}</FormLabel>
                <RadioGroup name="optionIndex" value={instructionData.optionIndex} onChange={handleChange}>
                  {selectedCarDetails.options.map((element, index) =>
                    <FormControlLabel key={element.description} value={index} control={<Radio />} label={settings.symbol + ' ' + element.amount + ' - ' + element.description} />
                  )}
                </RadioGroup>
              </FormControl>
              : null}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Button round onClick={() => handleEstimateChange()} variant="contained" color="success" style={{ marginLeft: 10 }}>
              {language.get_estimate}
            </Button>
            <Button simple onClick={()=>setOptionModalStatus(false)} variant="contained" color="warning">
              {language.cancel}
            </Button>
          </Grid>
        </Grid>
      </Modal>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={paymentModal}
        onClose={()=> setPaymentModal(false)}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid container spacing={2} className={classes.paper}>
          <Typography component="h3" variant="h6" color="primary" style={{ marginTop: 15 }}>
            Αποστολή - Πληρωμή
          </Typography>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography color={'warning'} style={{ fontSize: 20 }}>
              {language.total} : {settings ? settings.symbol : null} {estimated?.estimate ? estimated?.estimate?.estimateFare : null}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography color={'warning'} style={{ fontSize: 20 }}>
              Υπόλοιπο στο Πορτοφόλι: {settings ? settings.symbol : null} {auth?.info?.profile?.walletBalance ? auth?.info?.profile?.walletBalance:0}
            </Typography>
            <Typography color={'success'} style={{ fontSize: 12 }}>
              Φορτώστε χρήματα στο πορτοφόλι σας κατεβάζοντας την εφαρμογή και κερδίστε δώρο 10Ε
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Button round onClick={useAccountBalance} variant="contained" color="success" style={{ width: '100%' }}
              disabled={parseFloat(auth?.info?.profile?.walletBalance) < parseFloat(estimated?.estimate?.estimateFare)}>
              Πληρωμη με Πορτοφολι
            </Button>
            <Button round onClick={() => payment("cashOnDelivery")} variant="contained" color="success" style={{ width: '100%' }}>
             Μετρητα
            </Button>
            <Button round onClick={() => payment()} variant="contained" color="success" style={{ width: '100%'}}>
              Χρεωστικη-Πιστωτικη-Paypal
            </Button>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Button simple onClick={() => setPaymentModal(false)} variant="contained" color="warning" style={{ width: '100%' }}>
              {language.cancel}
            </Button>
          </Grid>
        </Grid>
      </Modal>
      <PaymentGateway paymentData={paymentData}/>
      <AlertDialog open={bookingdata?.booking ? true : false} onClose={handleBookingAlertClose}>{bookingdata?.booking ? language.booking_success : null}</AlertDialog>
      <AlertDialog open={bookingdata?.error?.flag} onClose={handleBookingErrorClose}>{bookingdata?.error?.msg}</AlertDialog>
      <AlertDialog open={estimated?.error?.flag} onClose={handleEstimateErrorClose}>{estimated?.error?.msg}</AlertDialog>
      <AlertDialog open={commonAlert?.open} onClose={handleCommonAlertClose}>{commonAlert?.msg}</AlertDialog>
    </div>
  );
}
